[
  {
    "code": "NONE",
    "label": {
      "en": "No formal education",
      "es": "Sin estudios"
    },
    "order": 0,
    "is_active": true
  },
  {
    "code": "PRIMARY",
    "label": {
      "en": "Primary Education",
      "es": "Educacion Primaria"
    },
    "order": 1,
    "is_active": true
  },
  {
    "code": "SECONDARY",
    "label": {
      "en": "Secondary Education (ESO)",
      "es": "Educacion Secundaria (ESO)"
    },
    "order": 2,
    "is_active": true
  },
  {
    "code": "HIGH_SCHOOL",
    "label": {
      "en": "High School (Bachillerato)",
      "es": "Bachillerato"
    },
    "order": 3,
    "is_active": true
  },
  {
    "code": "VOCATIONAL",
    "label": {
      "en": "Vocational Training (FP)",
      "es": "Formacion Profesional (FP)"
    },
    "order": 4,
    "is_active": true
  },
  {
    "code": "BACHELOR",
    "label": {
      "en": "Bachelor's Degree",
      "es": "Grado Universitario"
    },
    "order": 5,
    "is_active": true
  },
  {
    "code": "MASTER",
    "label": {
      "en": "Master's Degree",
      "es": "Master"
    },
    "order": 6,
    "is_active": true
  },
  {
    "code": "DOCTORATE",
    "label": {
      "en": "Doctorate (PhD)",
      "es": "Doctorado"
    },
    "order": 7,
    "is_active": true
  }
]
